<template>
  <el-dialog :title="getTitle"
             :visible.sync="showHoliday"
             @close="handleCancel"
             :close-on-click-modal="false"
             width="40%">
    <el-col :span="24">
      <el-form :model="holidayInfo"
               :rules="holidayRules"
               ref="holidayForm"
               label-width="90px"
               class="type-form">
        <el-form-item label="假日名称"
                      prop="name">
          <el-input v-model.trim="holidayInfo.name"
                    placeholder="请输入假日名称"></el-input>
        </el-form-item>
        <el-form-item label="开始时间:"
                      prop="dt_begin">
          <el-date-picker :picker-options="dateOption"
                          v-model="holidayInfo.dt_begin"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          type="datetime"
                          @change="timeChange"
                          placeholder="请选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间:"
                      prop="dt_end">
          <el-date-picker :picker-options="dateEndOption"
                          v-model="holidayInfo.dt_end"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          type="datetime"
                          @change="timeEndChange"
                          placeholder="请选择结束时间">
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="起止日期"
                      prop="time">
          <el-date-picker v-model="holidayInfo.dt_begin"
                          type="datetimerange"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item label="备注:"
                      prop="remarks">
          <el-input type="textarea"
                    v-model="holidayInfo.remarks"
                    placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/holiday/add' || '/holiday/edit'"
                 type="primary"
                 @click="handleConfirm('holidayForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showHoliday: this.isShow,
      holidayInfo: {
        name: '',
        dt_begin: '',
        dt_end: '',
        remarks: ''
      },
      holidayRules: {
        name: [{ required: true, message: '请输入假日名称' }],
        dt_begin: [{ required: true, message: '请选择假日开始日期' }],
        dt_end: [{ required: true, message: '请选择假日结束日期' }]
      },
      dateOption: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      dateEndOption: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.holidayInfo.dt_begin).getTime()
        }
      }
    }
  },
  computed: {
    getTitle() {
      return this.data.type === 'add' ? '添加假日设置' : '编辑假日设置'
    }
  },
  created() {
    if (this.data.type === 'edit') {
      this.getInfo()
    }
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getHolidayInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.holidayInfo = data
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 时间限制
    timeChange(time) {
      if (time < Date.now()) {
        this.holidayInfo.dt_begin = new Date().getTime()
      }
      this.holidayInfo.dt_end = ''
    },
    timeEndChange(time) {
      if (time < Date.now()) {
        this.holidayInfo.dt_end = new Date().getTime()
      }
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.data.type === 'add') {
            fetch.addHoliday({ ...this.holidayInfo }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          } else {
            fetch.editHoliday({ ...this.holidayInfo }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          }
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    }
  }
}
</script>

<style></style>
